export default "__VITE_ASSET__fId4xADd__"